import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Grid, IconButton, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import EditTextField from "../EditArticle/EditTextField";
import Divider from "@material-ui/core/Divider";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import cloudStore, { cloudStoreEvents } from "../../store/CloudStore";
import { setAuthentications, setProfiles, setRoles } from "../../store/CloudActions";
import EditMultipleSelect from "./EditMultiSelect";
import AddCircleIcon from "@material-ui/icons/AddCircle";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    width: "100%",
    marginBottom: 20,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  section: {
    // border: "orange 2px solid",
    position: "relative",
  },
  tagList: { display: "flex", margin: 0, padding: 0, flexFlow: "row wrap" },
  tag: {
    fontWeight: 800,
    borderRadius: 5,
    margin: "0 5px",
    listStyleType: "none",
  },
  label: { fontSize: "0.6rem" },
  selectPermissionContainer: { display: "flex", flexDirection: "row", margin: 0, marginBottom: 10 },
  rootIcon: { display: "inline", position: "absolute", right: 5, top: 5 },
}));

export default function AuthenticationDialog(props) {
  const classes = useStyles();
  const [allAuthentications, setAllAuthentications] = useState(cloudStore.authentications);
  const [selectedPermission, setSelectedPermission] = useState(props.authentication);
  const selectedAuthentication = allAuthentications[selectedPermission] ? allAuthentications[selectedPermission] : [];
  const [allProfiles, setAllProfiles] = useState(cloudStore.profiles);
  const [allRoles, setAllRoles] = useState(cloudStore.roles);
  const [newRole, setNewRole] = useState("");
  const [newProfile, setNewProfile] = useState("");
  const [errorMultiSelectProfiles, setErrorMultiSelectProfiles] = useState(null);
  const [errorMultiSelectRoles, setErrorMultiSelectRoles] = useState(null);

  const onStoreUpdate = () => {
    const newAllAuthentications = { ...cloudStore.authentications };
    setAllAuthentications(newAllAuthentications);
    setAllProfiles([...cloudStore.profiles]);
    setAllRoles([...cloudStore.roles]);
  };

  useEffect(() => {
    cloudStore.on(cloudStoreEvents.AUTHENTICATIONS_UPDATED, onStoreUpdate);
    cloudStore.on(cloudStoreEvents.PROFILES_UPDATED, onStoreUpdate);
    cloudStore.on(cloudStoreEvents.ROLES_UPDATED, onStoreUpdate);
    return () => {
      cloudStore.removeListener(cloudStoreEvents.AUTHENTICATIONS_UPDATED, onStoreUpdate);
      cloudStore.removeListener(cloudStoreEvents.PROFILES_UPDATED, onStoreUpdate);
      cloudStore.removeListener(cloudStoreEvents.ROLES_UPDATED, onStoreUpdate);
    };
  }, []);

  const createNewAuthorizedObject = (authorized) => {
    const newAuthObject = { authorized: authorized, profiles: [], roles: [] };
    const newSelectedPermission = [...selectedAuthentication];
    newSelectedPermission.push(newAuthObject);
    const newAllAuthentications = { ...allAuthentications, [selectedPermission]: newSelectedPermission };
    setAuthentications(newAllAuthentications);
  };

  const createProfile = (value) => {
    const newArray = [...allProfiles];
    newArray.push(value);
    setProfiles(newArray);
    setNewProfile("");
  };

  const createRole = (value) => {
    const newArray = [...allRoles];
    newArray.push(value);
    setRoles(newArray);
    setNewRole("");
  };

  const downloadFiles = (type) => {
    const element = document.createElement("a");
    const file = new Blob([JSON.stringify(cloudStore[type])], { type: "json/plain;charset=utf-8" });
    element.href = URL.createObjectURL(file);
    element.download = `${type}.json`;
    document.body.appendChild(element);
    element.click();
  };

  const deletePermission = (index, authObject, type) => {
    authObject[type].splice(index, 1);
    const newSelectedAuthentication = [...selectedAuthentication];
    const i = newSelectedAuthentication.findIndex((auth) => auth.authorized === authObject.authorized);
    newSelectedAuthentication.splice(i, 1, authObject);
    const newAllAuthentications = { ...allAuthentications, [selectedPermission]: newSelectedAuthentication };
    setAuthentications(newAllAuthentications);
  };

  const deleteAuthObject = (authObject) => {
    const newSelectedAuthentication = [...selectedAuthentication];
    const index = newSelectedAuthentication.findIndex((auth) => auth.authorized === authObject.authorized);
    newSelectedAuthentication.splice(index, 1);
    const newAllAuthentications = { ...allAuthentications, [selectedPermission]: newSelectedAuthentication };
    setAuthentications(newAllAuthentications);
  };

  const addProfileArrayToSelectedPermission = (authObject, selectedValues) => {
    if (
      authObject.profiles
        .map(
          (profileArray) =>
            Array.isArray(profileArray) &&
            Array.isArray(selectedValues) &&
            profileArray.length === selectedValues.length &&
            profileArray.every((val, index) => val === selectedValues[index])
        )
        .find((element) => element === true)
    ) {
      setErrorMultiSelectProfiles("profile (combination) already exists");
    } else {
      setErrorMultiSelectProfiles(null);
      authObject.profiles.push(selectedValues);
      const newSelectedPermission = [...selectedAuthentication];
      const index = newSelectedPermission.findIndex((auth) => auth.authorized === authObject.authorized);
      newSelectedPermission.splice(index, 1, authObject);
      const newAllAuthentications = { ...allAuthentications, [selectedPermission]: newSelectedPermission };
      setAuthentications(newAllAuthentications);
    }
  };

  const addRoleArrayToSelectedPermission = (authObject, selectedValues) => {
    if (
      authObject.roles
        .map(
          (rolesArray) =>
            Array.isArray(rolesArray) &&
            Array.isArray(selectedValues) &&
            rolesArray.length === selectedValues.length &&
            rolesArray.every((val, index) => val === selectedValues[index])
        )
        .find((element) => element === true)
    ) {
      setErrorMultiSelectRoles("profile (combination) already exists");
    } else {
      setErrorMultiSelectProfiles(null);
      authObject.roles.push(selectedValues);
      const newSelectedPermission = [...selectedAuthentication];
      const index = newSelectedPermission.findIndex((auth) => auth.authorized === authObject.authorized);
      newSelectedPermission.splice(index, 1, authObject);
      const newAllAuthentications = { ...allAuthentications, [selectedPermission]: newSelectedPermission };
      setAuthentications(newAllAuthentications);
    }
  };

  const handleQuickSelection = (selectedValues, type) => {
    const key = type === "profiles" ? "quick_selection_profiles" : "quick_selection_roles";

    let quickSelection = sessionStorage.getItem(key);
    if (quickSelection == null) {
      quickSelection = [];
    } else {
      quickSelection = JSON.parse(quickSelection);
    }

    if (
      !quickSelection
        .map(
          (selection) =>
            Array.isArray(selection) &&
            Array.isArray(selectedValues) &&
            selection.length === selectedValues.length &&
            selection.every((val, index) => val === selectedValues[index])
        )
        .find((element) => element === true)
    ) {
      if (quickSelection.length < 4) {
        quickSelection.push(selectedValues);
      } else {
        quickSelection.push(selectedValues);
        quickSelection.splice(0, 1);
      }
    }
    sessionStorage.setItem(key, JSON.stringify(quickSelection));
  };

  return (
    <>
      <DialogTitle id="form-dialog-title">Authentication</DialogTitle>
      <DialogContent>
        <div className={classes.root}>
          <Grid container spacing={3}>
            <Grid className={classes.section} item sm={12}>
              <b>Selected Authentication:</b> {selectedPermission}
            </Grid>
            {selectedAuthentication?.map((authObject) => (
              <Paper className={classes.paper} key={authObject.authorized}>
                <Grid className={classes.section} key={authObject.authorized} item container sm={12} xs={12}>
                  <Grid item className={classes.section} xs={12}>
                    <HighlightOffIcon
                      classes={{ root: classes.rootIcon }}
                      onClick={() => deleteAuthObject(authObject)}
                      fontSize={"small"}
                      color={"primary"}
                    />
                    {authObject.authorized === "w" ? "Write" : "Read"}:
                  </Grid>
                  <Grid item className={classes.section} sm={6} xs={12}>
                    <div className={classes.selectPermissionContainer}>
                      <EditMultipleSelect
                        key={authObject.profiles.length}
                        selectionValues={allProfiles}
                        authObject={authObject}
                        type={"Profiles"}
                        quickSelectionValues={
                          sessionStorage.getItem("quick_selection_profiles")
                            ? JSON.parse(sessionStorage.getItem("quick_selection_profiles"))
                            : []
                        }
                        handleOnClick={(selectedValues) => {
                          if (typeof selectedValues === "string") {
                            selectedValues = [selectedValues];
                          }
                          handleQuickSelection(selectedValues, "profiles");
                          addProfileArrayToSelectedPermission(authObject, selectedValues);
                        }}
                        errorMessage={errorMultiSelectProfiles}
                      />
                    </div>
                    <ul className={classes.tagList}>
                      {authObject.profiles.map((profileCombo, index) => (
                        <li key={profileCombo + index} className={classes.tag}>
                          <Button
                            classes={{ label: classes.label }}
                            startIcon={
                              <HighlightOffIcon
                                onClick={() => deletePermission(index, authObject, "profiles")}
                                fontSize={"small"}
                                color={"primary"}
                              />
                            }
                          >
                            <ul className={classes.tagList}>
                              {profileCombo.map((profile, index) => (
                                <li key={profile + index} className={classes.tag}>
                                  {profile}
                                </li>
                              ))}
                            </ul>
                          </Button>
                        </li>
                      ))}
                    </ul>
                  </Grid>
                  <Grid className={classes.section} item sm={6} xs={12}>
                    <div className={classes.selectPermissionContainer}>
                      <EditMultipleSelect
                        type={"Roles"}
                        key={authObject.roles.length}
                        selectionValues={allRoles}
                        authObject={authObject}
                        errorMessage={errorMultiSelectRoles}
                        quickSelectionValues={
                          sessionStorage.getItem("quick_selection_roles")
                            ? JSON.parse(sessionStorage.getItem("quick_selection_roles"))
                            : []
                        }
                        handleOnClick={(selectedValues) => {
                          if (typeof selectedValues === "string") {
                            selectedValues = [selectedValues];
                          }
                          handleQuickSelection(selectedValues, "roles");
                          addRoleArrayToSelectedPermission(authObject, selectedValues);
                        }}
                      />
                    </div>
                    <ul className={classes.tagList}>
                      {authObject.roles.map((roleCombo, index) => (
                        <li key={roleCombo + index} className={classes.tag}>
                          <Button
                            classes={{ label: classes.label }}
                            startIcon={
                              <HighlightOffIcon
                                onClick={() => deletePermission(index, authObject, "roles")}
                                fontSize={"small"}
                                color={"primary"}
                              />
                            }
                          >
                            <ul className={classes.tagList}>
                              {roleCombo.map((role, index) => (
                                <li key={role + index} className={classes.tag}>
                                  {role}
                                </li>
                              ))}
                            </ul>
                          </Button>
                        </li>
                      ))}
                    </ul>
                  </Grid>
                </Grid>
              </Paper>
            ))}
            {!selectedAuthentication?.find((auth) => auth.authorized === "w") && (
              <Paper className={classes.paper}>
                <Grid className={classes.section} item sm={12} xs={12}>
                  <IconButton color={"primary"} onClick={() => createNewAuthorizedObject("w")}>
                    <AddCircleIcon /> <Button classes={{ label: classes.label }}>Write authorization</Button>
                  </IconButton>
                </Grid>
              </Paper>
            )}
            {!selectedAuthentication?.find((auth) => auth.authorized === "r") && (
              <Paper className={classes.paper}>
                <Grid className={classes.section} item sm={12} xs={12}>
                  <IconButton color={"primary"} onClick={() => createNewAuthorizedObject("r")}>
                    <AddCircleIcon /> <Button classes={{ label: classes.label }}>Read authorization</Button>
                  </IconButton>
                </Grid>
              </Paper>
            )}
            <Grid className={classes.section} item sm={12}>
              <Divider style={{ margin: 20 }} />
              <div>
                <b>All Profiles:</b>
                <ul className={classes.tagList}>
                  {allProfiles.map((profile, index) => (
                    <li key={profile + index} className={classes.tag}>
                      <Button classes={{ label: classes.label }}>{profile}</Button>
                    </li>
                  ))}
                </ul>
                <EditTextField
                  value={newProfile}
                  key={new Date().toLocaleTimeString()}
                  placeholder={"new profile"}
                  fullWidth={false}
                  onBlur={(value) => {
                    setNewProfile(value);
                    if (value.length > 0) {
                      createProfile(value);
                    }
                  }}
                  variant={"standard"}
                />
              </div>
            </Grid>
            <Grid className={classes.section} item sm={12}>
              <Divider style={{ margin: 20 }} />
              <div>
                <b> All Roles:</b>
                <ul className={classes.tagList}>
                  {allRoles.map((role, index) => (
                    <li key={role + index} className={classes.tag}>
                      <Button classes={{ label: classes.label }}> {role}</Button>
                    </li>
                  ))}
                </ul>
                <EditTextField
                  value={newRole}
                  key={new Date().toLocaleTimeString()}
                  placeholder={"new role"}
                  fullWidth={false}
                  onBlur={(value) => {
                    setNewRole(value);
                    if (value.length > 0) {
                      createRole(value);
                    }
                  }}
                  variant={"standard"}
                />
              </div>
            </Grid>
            <Grid className={classes.section} item sm={12}>
              <Divider style={{ margin: 20 }} />{" "}
              <div>
                <b>All Authentications:</b>
                <ul className={classes.tagList}>
                  {Object.keys(allAuthentications)
                    .sort()
                    .map((auth, index) => (
                      <li key={auth + index} className={classes.tag}>
                        <Button onClick={() => setSelectedPermission(auth)} classes={{ label: classes.label }}>
                          {auth}
                        </Button>
                      </li>
                    ))}
                </ul>
              </div>
            </Grid>
          </Grid>
        </div>
      </DialogContent>
      <DialogActions>
        <Button classes={{ label: classes.label }} onClick={() => downloadFiles("roles")} color="primary">
          Download Roles
        </Button>
        <Button classes={{ label: classes.label }} onClick={() => downloadFiles("profiles")} color="primary">
          Download Profiles
        </Button>
        <Button classes={{ label: classes.label }} onClick={() => downloadFiles("authentications")} color="primary">
          Download Authentications
        </Button>
      </DialogActions>
    </>
  );
}
